import { WizardFormDto } from "@/types/wizard.type";
import httpAuth from "../common/http/http-common";

class WizardService {
  client = httpAuth("wizard");

  async hasViewedWizardAsync(userId: number): Promise<boolean | null> {
    const { data } = await this.client.get(`user/${userId}/view`);

    return data;
  }

  async validateUsernameAsync(username: string): Promise<void> {
    const { data } = await this.client.get(`validate/username?username=${username}`);
    
    return data;
  }

  async finishAsync(form: WizardFormDto): Promise<void> {
    const { data } = await this.client.post("finish", form);

    return data;
  }
}

export default new WizardService();